"use client";

import { useIsMobile } from "@/features/layout/useIsMobile";
import { useProjectConfigs } from "@/features/project/ProjectContext";

/**
 * Whether the result list is scoped to what the map is showing.
 *
 * Shared by the hook that writes the viewport and the query that reads it, so
 * the two can't disagree. They previously each decided for themselves, and the
 * reader only checked `isBboxIncluded`: on a narrow window, where tracking is
 * off, a bbox measured before the window was resized stayed in the query key and
 * kept filtering a list that had no map beside it.
 *
 * Off on mobile because the map and the list are separate views there — panning
 * the map must not silently change a list the user isn't looking at.
 */
export function useIsBboxTracked(): boolean {
  const { isBboxIncluded } = useProjectConfigs();
  const isMobile = useIsMobile();

  return !!isBboxIncluded && !isMobile;
}
